import React, { useState } from 'react';
import { trackNavigationLinkClicked } from '../../../tracking/events';
import { isKeyboardEvent } from '../../../util';
import { ButtonTrackingProps } from './Button';

export interface ImageButtonProps extends Omit<ButtonTrackingProps, 'text'> {
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  key?: string;
  tabIndex?: number;
  image: React.ReactElement<HTMLImageElement>;
}

export const ImageButton: React.FC<ImageButtonProps> = ({ onClick, tabIndex, dataTrackLabel, dataTrackLocation, image }) => {
  const [, setHovering] = useState<boolean>(false);
  const buttonOnClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    if (isKeyboardEvent(e)) {
      if (e.key !== 'Enter') {
        return;
      }
    }

    if (dataTrackLabel && dataTrackLocation) {
      trackNavigationLinkClicked(dataTrackLabel, dataTrackLocation);
    }
    if (onClick) {
      onClick?.(e);
      e.preventDefault();
    }
  };

  const onMouseEnter = () => {
    setHovering(true);
  };
  const onMouseLeave = () => {
    setHovering(false);
  };

  return (
    <div
      tabIndex={tabIndex ?? 0}
      role="button"
      onClick={buttonOnClick}
      onKeyDown={buttonOnClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ cursor: 'pointer' }}
    >
      {image}
    </div>
  );
};

export default ImageButton;
